import { use } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import DeleteSetupDialog from "../../components/DeleteSetupDialog";
import Header from "../../components/Header";
import Icon from "../../components/Icon";
import { BikeContext } from "../../context/bikeContext";
import { EditModeContext } from "../../context/editModeContext";
import { useExportSetupAsPdf, useSetup } from "../../hooks/useSetups";
import useToggle from "../../hooks/useToggle";
import Page from "../../layouts/Page";
import Delete from "./../../components/icons/delete.svg?react";
import Download from "./../../components/icons/download.svg?react";

const SetupPage = () => {
  const params = useParams<"setupId">();
  const setupId = String(params.setupId);
  const { data: setup } = useSetup(setupId);
  const { bike } = use(BikeContext);
  const location = useLocation();
  const editMode = use(EditModeContext);
  const deleteDialog = useToggle();
  const exportSetupAsPdf = useExportSetupAsPdf(setupId);

  return (
    <>
      <Header
        backLink="/setups"
        heading={setup?.name}
        subHeading={bike?.name}
        tabs={[
          { to: "settings", text: "Settings" },
          { to: "history", text: "History" },
        ]}
      >
        {location.pathname.includes("/settings") && !editMode.isOpen && (
          <>
            <button
              onClick={() => {
                exportSetupAsPdf.mutate();
              }}
            >
              <Icon glyph={Download} />
            </button>
            <button onClick={() => deleteDialog.open()}>
              <Icon glyph={Delete} />
            </button>
          </>
        )}
      </Header>
      <Page>
        <Outlet />
      </Page>
      <DeleteSetupDialog
        setupId={setupId}
        open={deleteDialog.isOpen}
        onClose={deleteDialog.close}
      />
    </>
  );
};

export default SetupPage;
